package com.essntl.features.itinerary.ui.all_itinerary.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.itinerary.domain.model.ItineraryFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryOrderType
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.dropdown.EsFilterDropDownItem
import com.essntl.uikit.components.dropdown.EsFilterDropDownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberEquals

@Composable
fun ItineraryFilterSection(
    filterOptions: ItineraryFilterOptions,
    onFilterOptionsChange: (ItineraryFilterOptions) -> Unit,
) {
    var isSortFilterExpanded by remember { mutableStateOf(false) }
    val itineraryOrderTypes =
        listOf(
            ItineraryOrderType.Alphabetical,
            ItineraryOrderType.LastCreated,
            ItineraryOrderType.StartDate,
        )

    Box {
        EsMediumOutlineButton(
            text = filterOptions.selectedItineraryOrderType.orderName,
            onClick = {
                isSortFilterExpanded = !isSortFilterExpanded
            },
            suffixIconRes = EsIcons.Sort,
        )

        EsFilterDropDownMenu(
            expanded = isSortFilterExpanded,
            onDismissRequest = { isSortFilterExpanded = false },
            list = itineraryOrderTypes,
            selectedItemIds = setOf(filterOptions.selectedItineraryOrderType),
            clearing = false,
            content = {
                itineraryOrderTypes.forEach { order ->
                    val isSelected = rememberEquals(
                        order,
                        setOf(filterOptions.selectedItineraryOrderType),
                    ) { it }

                    key(order) {
                        EsFilterDropDownItem(
                            onClick = {
                                onFilterOptionsChange(
                                    filterOptions.copy(
                                        selectedItineraryOrderType =
                                        if (order == filterOptions.selectedItineraryOrderType)
                                            ItineraryOrderType.Default
                                        else
                                            order,
                                    ),
                                )
                            },
                            title = order.orderName,
                            selected = isSelected,
                            modifier = Modifier
                                .padding(
                                    vertical = .5f.spacing,
                                    horizontal = 1.5f.spacing,
                                ),
                        )
                    }
                }
            },
            modifier = Modifier
                .width(308.dp),
        )
    }
}